import { createContext } from "react";

export interface TrackingScopeValue {
  entityType?: "artist" | "company" | "offer" | "release" | "work";
  surface: string;
}

export const TrackingScopeContext = createContext<Partial<TrackingScopeValue>>({});
